import { t } from "ttag";

import { reverse } from "@reactivated";

import { getDocument, getWindow } from "@thelabnyc/thelabui/src/utils/dom";

import { PAYMENT_SUBMIT_TIMEOUT_MS } from "../constants";
import {
    ICybersourceFieldMapping,
    ICybersourceRequest,
    ICybersourceTemplate,
    ICybersourceTemplateContext,
} from "../models/checkout";

const getCountryCode = (url: string) => {
    // TODO: make this less awful
    const segments = url.split("/");
    return segments[segments.indexOf("countries") + 1];
};

export const renderRequestTemplate = (
    data: ICybersourceTemplateContext,
    template: ICybersourceTemplate,
): ICybersourceRequest => {
    const fieldMapping: ICybersourceFieldMapping = {
        card_type: "card_type",
        card_number: "card_number",
        card_expiry_date: "card_expiration",
        card_cvn: "card_cvc",
        bill_to_forename: "billing_first_name",
        bill_to_surname: "billing_last_name",
        bill_to_phone: "billing_phone_number",
        bill_to_email: "email",
        bill_to_address_line1: "billing_line1",
        bill_to_address_line2: "billing_line2",
        bill_to_address_city: "billing_line4",
        bill_to_address_postal_code: "billing_postcode",
        bill_to_address_state: "billing_state",
        bill_to_address_country: "billing_country",
    };

    // Build the data object immutably
    const requestData: ICybersourceRequest["data"] = {};
    template.fields.forEach((field) => {
        const inputKey = fieldMapping[field.key];
        const inputValue = data[inputKey];
        let value = field.value;

        if (field.editable && inputValue) {
            value = inputValue;
        }

        (requestData as Record<string, string>)[field.key] = value;
    });

    // Apply transformations immutably
    const century = `${new Date().getFullYear()}`.slice(0, 2);
    const transformedData: ICybersourceRequest["data"] = {
        ...requestData,
        card_number: (requestData.card_number || "").replace(/\s+/g, ""),
        card_expiry_date: (requestData.card_expiry_date || "").replace(
            /([0-9]{2})\/([0-9]{2})/,
            `$1-${century}$2`,
        ),
        bill_to_phone: (requestData.bill_to_phone || "").replace(
            /[^0-9]+/g,
            "",
        ),
        bill_to_address_country: getCountryCode(
            requestData.bill_to_address_country ||
                reverse("country-detail", { pk: "US" }),
        ),
    };

    return {
        url: template.url,
        data: transformedData,
    };
};

export const submitRequest = (
    request: ICybersourceRequest,
    frameSrc = "/store/checkout/payment-submit/",
): void => {
    const window = getWindow();
    const document = getDocument();
    if (!window || !document) {
        return;
    }

    const frame = document.createElement("iframe");
    frame.src = frameSrc;
    frame.style.display = "none";
    frame.style.border = "none";
    frame.width = "0";
    frame.height = "0";
    // set timeout to catch stalled payment token requests
    const origin = window.location.href;
    const message = { type: "TSI_CHECKOUT_PAYMENT_TIMEOUT" };
    window.setTimeout(function () {
        window.postMessage(message, origin);
    }, PAYMENT_SUBMIT_TIMEOUT_MS);
    document.body.appendChild(frame);
    console.log(
        `Payment Submit Iframe created, ${PAYMENT_SUBMIT_TIMEOUT_MS / 1000} seconds until timeout`,
    );
    const frameDoc = frame.contentWindow
        ? frame.contentWindow.document
        : frame.contentDocument;
    if (!frameDoc) {
        throw new Error(t`iframe is missing document object`);
    }

    const form = frameDoc.createElement("form");
    form.method = "POST";
    form.action = request.url;
    const dataKeys = Object.keys(request.data) as Array<
        keyof ICybersourceRequest["data"]
    >;
    for (const key of dataKeys) {
        const elem = frameDoc.createElement("input");
        elem.type = "hidden";
        elem.name = key;
        elem.value = request.data[key] || "";
        form.appendChild(elem);
    }
    const submitForm = () => {
        console.log("trying to submit appended form from iframe");
        frameDoc.body.appendChild(form);
        form.submit();
    };
    if (frameDoc.body) {
        console.log("submitting token request form");
        submitForm();
    } else {
        frame.onload = submitForm;
    }
};
